import * as React from 'react';
import { Coverage } from '../../../types/Coverage';
import MobileCoverageListElement from '../ExtraCoverage/MobileCoverageListElement';
import classNames from 'classnames';
import {
    isOkq8,
    isVillaagarna
} from '../../../services/partners/partnersService';
import { Text } from '@gje/typography/lib';

interface CardsProps {
    insuranceData: any;
    allCoveragesList: Coverage[];
    openCoverageIndex: number;
    setOpenCoverageIndex: Function;
    additionalContentMap?: any[];
    chosenInsuranceIndex?: number;
}

const MobileExpandablePanel: React.FC<CardsProps> = ({
    insuranceData,
    allCoveragesList,
    openCoverageIndex,
    setOpenCoverageIndex,
    additionalContentMap,
    chosenInsuranceIndex
}) => {
    const renderExtraCoveragesList = (
        availableCoverages: string[],
        allCoverages: Coverage[]
    ) => {
        return allCoverages.map((coverage, index) => (
            <MobileCoverageListElement
                key={index}
                coverageData={coverage}
                availableCoverages={availableCoverages}
                isOpen={openCoverageIndex === index}
                onClick={() =>
                    setOpenCoverageIndex(
                        index === openCoverageIndex ? -1 : index
                    )
                }
            />
        ));
    };

    const handleCardClick = e => {
        if (
            !e.target.classList.contains('dont-hide-card-click') &&
            e.target.tagName != 'H6'
        ) {
            setOpenCoverageIndex(-1);
        }
    };

    const resolveAdditionalConent = () => {
        if (additionalContentMap) {
            switch (chosenInsuranceIndex) {
                case 0:
                    return additionalContentMap[0].map(entry => (
                        <Text size={'h5'}>
                            {Object.values(entry)[0]}: {Object.values(entry)[1]}
                        </Text>
                    ));
                case 1:
                default:
                    return additionalContentMap[1].map(entry => (
                        <Text size={'h5'}>
                            {Object.values(entry)[0]}: {Object.values(entry)[1]}
                        </Text>
                    ));
                case 2:
                    return additionalContentMap[2].map(entry => (
                        <Text size={'h5'}>
                            {Object.values(entry)[0]}: {Object.values(entry)[1]}
                        </Text>
                    ));
            }
        }
    };
    return (
        <div
            className={classNames(
                'col-xs-23',
                `${
                    isVillaagarna() ? 'villaagarna-' : isOkq8() ? 'okq8-' : ''
                }mobile-expandable-panel`
            )}
            key="expandablePanel"
            onClick={handleCardClick}>
            <div className={'padding-left-16'}>{resolveAdditionalConent()}</div>
            <ul
                key="extraCoveragesList"
                className={'mobile-extra-coverages-list'}>
                {renderExtraCoveragesList(
                    insuranceData.availableCoverages,
                    allCoveragesList
                )}
            </ul>
        </div>
    );
};

export default MobileExpandablePanel;
